import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Select from "../../../components/ui/Select";

const ReportModal = ({ isOpen, onClose, onSubmit, language }) => {
    
  const [formData, setFormData] = useState({
    from: "",
    to: "",
  /*  area_id: "",
    agent: ""*/
  });

  const [errors, setErrors] = useState({});

  const labels = {
    title: { en: "Generate Report", ar: "إصدار تقرير" },
    from: { en: "From Date", ar: "من تاريخ" },
    to: { en: "To Date", ar: "إلى تاريخ" },
    area: { en: "Area", ar: "المنطقة" },
    agent: { en: "Agent", ar: "المندوب" },
    generate: { en: "Generate", ar: "إصدار" },
    cancel: { en: "Cancel", ar: "إلغاء" },
    required: { en: "Required field", ar: "حقل مطلوب" }
  };

  // 🔥 مثال options - لاحقاً تربطه API
  const areaOptions = [
    { value: 1, label: "بغداد" },
    { value: 2, label: "البصرة" }
  ];

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validate = () => {
    const e = {};
    if (!formData.from) e.from = labels.required[language];
    if (!formData.to) e.to = labels.required[language];
   

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    onSubmit(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4">
      <div className="bg-card w-full max-w-xl rounded-xl border border-border shadow-lg overflow-y-auto max-h-[90vh]">

        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b sticky top-0 bg-card">
          <h2 className="text-xl font-semibold">
            {labels.title[language]}
          </h2>
          <button onClick={onClose}>
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">

          {/* Dates */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              type="date"
              label={labels.from[language]}
              value={formData.from}
              onChange={(e) => handleChange("from", e.target.value)}
              error={errors.from}
            />

            <Input
              type="date"
              label={labels.to[language]}
              value={formData.to}
              onChange={(e) => handleChange("to", e.target.value)}
              error={errors.to}
            />
          </div>

          {/* Area
          <Select
            label={labels.area[language]}
            options={areaOptions}
            value={formData.area_id}
            onChange={(v) => handleChange("area_id", v)}
            error={errors.area_id}
          /> */}

          {/* Agent 
          <Input
            label={labels.agent[language]}
            value={formData.agent}
            onChange={(e) => handleChange("agent", e.target.value)}
          />*/}

          {/* Actions */}
          <div className="flex gap-3 pt-4">
            <Button type="button" variant="outline" onClick={onClose}>
              {labels.cancel[language]}
            </Button>
            <Button type="submit">
              {labels.generate[language]}
            </Button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default ReportModal;